var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-icon",class:{ 'size-small': _vm.size == 'small', 'size-large': _vm.size == 'large' }},[_c('svg',[_c('use',{attrs:{"xlink:href":'#' + _vm.name}})])])}
var staticRenderFns = []

export { render, staticRenderFns }